import styles from '@/components/Header/Header.module.scss'
import {Tabs, TabsProps} from 'antd/lib'
import GuidesTab from '@/components/Header/Notifications/GuidesTab'
import NotificationsTab from '@/components/Header/Notifications/NotificationsTab'

const items: TabsProps['items'] = [
  {
    key: 'notifications',
    label: 'Thông báo',
    children: <NotificationsTab />,
  },
  {
    key: 'guides',
    label: 'Hướng dẫn',
    children: <GuidesTab />,
  },
]

const HeaderNotification = () => {
  return (
    <div className={styles.menuBgShadow + ' ' + styles.menuNotificationsWrapper}>
      <Tabs defaultActiveKey={'notifications'} items={items} destroyInactiveTabPane />
    </div>
  )
}

export default HeaderNotification
